import useTrackPageView from "@/eventStream/useTrackPageView";

const PageViewTrigger = () => {
  useTrackPageView();
  return null;
};

export default PageViewTrigger;
